module.exports = __webpack_public_path__ + "static/media/gas.21ab5df3.jpeg";